var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	"webpack/sharing/consume/default/react/react": () => (loadSingletonVersion("default", "react", false, [1,18,2,18], () => (__webpack_require__.e("vendors-node_modules_react_index_js").then(() => (() => (__webpack_require__(/*! react */ "./node_modules/react/index.js"))))))),
	"webpack/sharing/consume/default/@emotion/react/@emotion/react": () => (loadStrictVersion("default", "@emotion/react", false, [1,11,14,0], () => (Promise.all([__webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_extends_js-node_modules_emotion_serialize_dist-dcfa94"), __webpack_require__.e("vendors-node_modules_emotion_react_dist_emotion-react_browser_development_esm_js")]).then(() => (() => (__webpack_require__(/*! @emotion/react */ "./node_modules/@emotion/react/dist/emotion-react.browser.development.esm.js"))))))),
	"webpack/sharing/consume/default/@ucl/context/@ucl/context": () => (loadStrictVersion("default", "@ucl/context", false, [1,6,2,2], () => (__webpack_require__.e("vendors-node_modules_ucl_context_index_js").then(() => (() => (__webpack_require__(/*! @ucl/context */ "./node_modules/@ucl/context/index.js"))))))),
	"webpack/sharing/consume/default/@emotion/styled/@emotion/styled": () => (loadStrictVersion("default", "@emotion/styled", false, [1,11,14,1], () => (Promise.all([__webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_extends_js-node_modules_emotion_serialize_dist-dcfa94"), __webpack_require__.e("webpack_sharing_consume_default_emotion_is-prop-valid_emotion_is-prop-valid"), __webpack_require__.e("node_modules_emotion_styled_dist_emotion-styled_browser_development_esm_js-_0cd11")]).then(() => (() => (__webpack_require__(/*! @emotion/styled */ "./node_modules/@emotion/styled/dist/emotion-styled.browser.development.esm.js"))))))),
	"webpack/sharing/consume/default/@emotion/is-prop-valid/@emotion/is-prop-valid": () => (loadStrictVersion("default", "@emotion/is-prop-valid", false, [1,1,3,1], () => (__webpack_require__.e("node_modules_emotion_is-prop-valid_dist_emotion-is-prop-valid_esm_js").then(() => (() => (__webpack_require__(/*! @emotion/is-prop-valid */ "./node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js"))))))),
	"webpack/sharing/consume/default/react-dom/react-dom": () => (loadSingletonVersion("default", "react-dom", false, [1,18,2,7], () => (__webpack_require__.e("vendors-node_modules_react-dom_index_js").then(() => (() => (__webpack_require__(/*! react-dom */ "./node_modules/react-dom/index.js"))))))),
	"webpack/sharing/consume/default/react-router/react-router": () => (loadSingletonVersion("default", "react-router", false, [1,7,18,0], () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-router_dist_development_chunk-ZA36QIGN_mjs"), __webpack_require__.e("node_modules_react-router_dist_development_index_mjs-_20af1")]).then(() => (() => (__webpack_require__(/*! react-router */ "./node_modules/react-router/dist/development/index.mjs"))))))),
	"webpack/sharing/consume/default/react-router-dom/react-router-dom": () => (loadSingletonVersion("default", "react-router-dom", false, [1,7,18,0], () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-router_dist_development_chunk-ZA36QIGN_mjs"), __webpack_require__.e("vendors-node_modules_react-router-dom_dist_index_mjs")]).then(() => (() => (__webpack_require__(/*! react-router-dom */ "./node_modules/react-router-dom/dist/index.mjs"))))))),
	"webpack/sharing/consume/default/@tanstack/react-query/@tanstack/react-query": () => (loadStrictVersion("default", "@tanstack/react-query", false, [1,4,36,1], () => (__webpack_require__.e("vendors-node_modules_tanstack_react-query_build_lib_index_mjs").then(() => (() => (__webpack_require__(/*! @tanstack/react-query */ "./node_modules/@tanstack/react-query/build/lib/index.mjs"))))))),
	"webpack/sharing/consume/default/@cxc/react-universal-components/@cxc/react-universal-components": () => (loadSingletonVersion("default", "@cxc/react-universal-components", false, [2,0,76,18,,"alpha",4], () => (__webpack_require__.e("vendors-node_modules_cxc_react-universal-components_index_js").then(() => (() => (__webpack_require__(/*! @cxc/react-universal-components */ "./node_modules/@cxc/react-universal-components/index.js"))))))),
	"webpack/sharing/consume/default/zod/zod": () => (loadStrictVersion("default", "zod", false, [1,3,23,8], () => (__webpack_require__.e("vendors-node_modules_zod_index_js").then(() => (() => (__webpack_require__(/*! zod */ "./node_modules/zod/index.js"))))))),
	"webpack/sharing/consume/default/react-helmet/react-helmet": () => (loadStrictVersion("default", "react-helmet", false, [1,6,1,0], () => (__webpack_require__.e("vendors-node_modules_react-helmet_es_Helmet_js").then(() => (() => (__webpack_require__(/*! react-helmet */ "./node_modules/react-helmet/es/Helmet.js"))))))),
	"webpack/sharing/consume/default/axios/axios": () => (loadStrictVersion("default", "axios", false, [1,1,18,0], () => (__webpack_require__.e("vendors-node_modules_axios_index_js").then(() => (() => (__webpack_require__(/*! axios */ "./node_modules/axios/index.js"))))))),
	"webpack/sharing/consume/default/html-react-parser/html-react-parser": () => (loadStrictVersion("default", "html-react-parser", false, [1,5,1,8], () => (__webpack_require__.e("vendors-node_modules_html-react-parser_esm_index_mjs").then(() => (() => (__webpack_require__(/*! html-react-parser */ "./node_modules/html-react-parser/esm/index.mjs"))))))),
	"webpack/sharing/consume/default/web-vitals/web-vitals": () => (loadStrictVersion("default", "web-vitals", false, [1,1,1,2], () => (__webpack_require__.e("node_modules_web-vitals_dist_web-vitals_js").then(() => (() => (__webpack_require__(/*! web-vitals */ "./node_modules/web-vitals/dist/web-vitals.js")))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"webpack_sharing_consume_default_react_react": [
		"webpack/sharing/consume/default/react/react"
	],
	"webpack_sharing_consume_default_emotion_react_emotion_react": [
		"webpack/sharing/consume/default/@emotion/react/@emotion/react"
	],
	"webpack_sharing_consume_default_emotion_styled_emotion_styled-webpack_sharing_consume_default-3bda96": [
		"webpack/sharing/consume/default/@ucl/context/@ucl/context",
		"webpack/sharing/consume/default/@emotion/styled/@emotion/styled"
	],
	"webpack_sharing_consume_default_emotion_is-prop-valid_emotion_is-prop-valid": [
		"webpack/sharing/consume/default/@emotion/is-prop-valid/@emotion/is-prop-valid"
	],
	"webpack_sharing_consume_default_react-dom_react-dom-webpack_sharing_consume_default_react-rou-7714db": [
		"webpack/sharing/consume/default/react-dom/react-dom",
		"webpack/sharing/consume/default/react-router/react-router"
	],
	"src_MainSwitch_tsx-src_hooks_useConsentMutation_ts-src_pages_ConsentPage_tsx": [
		"webpack/sharing/consume/default/react-router-dom/react-router-dom",
		"webpack/sharing/consume/default/@tanstack/react-query/@tanstack/react-query",
		"webpack/sharing/consume/default/@cxc/react-universal-components/@cxc/react-universal-components",
		"webpack/sharing/consume/default/zod/zod",
		"webpack/sharing/consume/default/react-helmet/react-helmet",
		"webpack/sharing/consume/default/axios/axios",
		"webpack/sharing/consume/default/html-react-parser/html-react-parser"
	],
	"webpack_sharing_consume_default_web-vitals_web-vitals": [
		"webpack/sharing/consume/default/web-vitals/web-vitals"
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}